import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ContentSwitcher from 'components/common/components/switcher/ContentSwitcher';
import ZonesList from 'components/zones/ZonesList';
import ApprovedAreasList from 'components/approvedAreas/List';
// import FilterDateTime from 'components/common/components/timePicker/FilterDateTime';

import { SidebarMenuDetailsUseStyles } from 'components/sidebar/SidebarMenuDetailsUseStyles';

const AirSpaceTable = props => {
  const { details, language } = props;
  const classes = SidebarMenuDetailsUseStyles();
  return (
    <div className={`${classes.SidebarMenuDetails}__table__details`}>
      {details === 'zones' ? (
        <ContentSwitcher
          textLeft={language.zonesDetails.public_}
          textRight={language.zonesDetails.private_}
          LeftElement={<ZonesList zonesType="public" />}
          RightElement={<ZonesList zonesType="private" />}
        />
      ) : null}

      {details === 'corridors' ? <ApprovedAreasList /> : null}
    </div>
  );
};

AirSpaceTable.propTypes = {
  details: PropTypes.string,
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(AirSpaceTable);
